import { ReactComponent as IconLogo } from 'assets/images/i-logo-small.svg'
import { Container, IconWrapper, ShieldProps, Overlay } from './Shield.styled'

const Shield: React.FC<ShieldProps> = ({ variant }) => {
  return (
    <>
      <Container variant={variant} data-test='Shield'>
        <IconWrapper variant={variant}>
          <IconLogo data-test='ShieldIconLogo' />
        </IconWrapper>
      </Container>
      <Overlay variant={variant} />
    </>
  )
}

export default Shield
